module.exports = __webpack_public_path__ + "static/media/earthrise.65e19f9b.jpg";